import { useState } from 'react';
import { encode } from 'querystring';

import { handlePartialUpload } from '../../Utils/Upload.jsx';
import { API_ENDPOINTS } from '../../common.js';

/** Gestion de l'enregistrement d'une participation vidéo
 * 
 * @param {dict} interaction 
 * @param {function} setSendingParticipationState 
 * @param {function} changerPage 
 * @param {dict} extraUserInformation 
 * @returns 
 */
export function ManageVideoRecorder(
    participation,
    setSendingParticipationState,
    setContinueEnabled,
    changerPage,
    extraUserInformation={}
) {
    const [videoURL, setVideoURL] = useState();
    const [videoBlob, setVideoBlob] = useState();
    const sendRecordParticipation = async () => {
        // Check mandatory
        //let withError = await checkMandatoryFields();
        //if (withError)
        //    return;

        // Save exxtraUserInformation if asked or delete them
        // Sauvegarder les extraUserInformation si souhaitée sinon les supprimer
        //saveRemeberMe();

        setSendingParticipationState('sending');
        setContinueEnabled(false);
        const extension = 'webm';
        const file = new File([videoBlob], `recording.${extension}`, { type: `video/${extension}` });
        // Initialize upload (get url storage)
        const { data_id, url } = await fetch(API_ENDPOINTS.upload, {
            method: 'POST',
            body: JSON.stringify({ extension }),
            headers: {
                'content-type': 'application/json'
            }
        }).then(response => {
            if (response.status >= 400) {
                console.log(response);
                throw new Error("Server respond with error !");
            }
            else {
                participation.id = response.id;
                return response.json();
            }
        });
        // Processed to upload using previous storage url
        await handlePartialUpload(file, url);
        // Gestion des données dans le cas d'un témoinage
        let content = {}
        if (participation.voteValue) {
            content = participation.voteValue;
        }
        content.text = participation.textAnswer;
        // Create intreaction
        const query = {
            channel_id: participation.channel_id,
            segment: participation.id,
            language: participation.language,
            device_id: participation.device_id,
            extra_user_information: participation.extra_user_information,
            content: content,
            data_id,
            extension
        };
        // PUT method is for voice recording

        await fetch(API_ENDPOINTS.interactions + `?${encode(query)}`,
            {
                method: "PUT",
                headers: {
                    'Content-Disposition': 'form-data; name="file"; filename="recording.webm"',
                    'Content-Type': 'video/webm',
                    'Extra-User-Information': JSON.stringify(extraUserInformation),
                }
            }).then(response => {
                if (response.status >= 400) {
                    console.log(response);
                    throw new Error("Server respond with error !");
                }
                else {
                    return response.json();
                }
            });
        setSendingParticipationState('sended');
        changerPage();
    };
    return {
        videoBlob,
        setVideoBlob,
        sendRecordParticipation,
        videoURL,
        setVideoURL,
    }
}